import './heroCanvasV2.js';
import './featureShowcase.js';

$(function () {
    let reduceMotion = localStorage.getItem('reduceMotion');

    if (document.getElementById('homeHero')) {
        let paused = false;
        $('#heroAnimationPause').on('click', () => {
            const $section = $('#homeHero');
            const $pauseTxt = $('#heroAnimationPauseText');
            const $resumeTxt = $('#heroAnimationResumeText');
            const $pauseIcon = $('#heroAnimationPauseIcon');
            const $playIcon = $('#heroAnimationPlayIcon');
            if (!paused) {
                paused = true;
                $section.addClass('animationPaused');
                $resumeTxt.removeClass('hidden');
                $pauseTxt.addClass('hidden');
                $playIcon.removeClass('hidden');
                $pauseIcon.addClass('hidden');
            } else {
                paused = false;
                $section.removeClass('animationPaused');
                $pauseTxt.removeClass('hidden');
                $resumeTxt.addClass('hidden');
                $pauseIcon.removeClass('hidden');
                $playIcon.addClass('hidden');
            }
        });
        if (reduceMotion === 'true') {
            setTimeout(function () {
                $('#heroAnimationPause').trigger('click');
            }, 500);
        }
    }
});

// Enable HMR for Vite
if (import.meta.hot) {
    import.meta.hot.accept();
}
